export default __webpack_public_path__ + "static/char-v-53-zh-Hant-5d70f534988b4228b084434462352bc9.mp4";